export default "__VITE_ASSET__DMlrwfch__"